import Vue from 'vue'
import App from './App.vue'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)
Vue.use(mavonEditor)
Vue.config.productionTip = false
new Vue({
    render: h => h(App),
}).$mount('#app')
